import React, { useEffect, useState } from 'react'
import { getApiErrorMessage, getFanvueFinancialStatus, syncFanvuePurchases } from '../api'

export default function FanvueFinancialHistory({ modelId, onAuthorize, authorizationBusy = false }) {
  const [status, setStatus] = useState(null)
  const [refresh, setRefresh] = useState(0)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [result, setResult] = useState(null)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  useEffect(() => {
    let current = true
    setStatus(null)
    getFanvueFinancialStatus(modelId).then((data) => { if (current) setStatus(data) })
      .catch((err) => { if (current) setError(getApiErrorMessage(err, 'Cannot check purchase history access')) })
    return () => { current = false }
  }, [modelId, refresh])
  async function sync() {
    setBusy(true); setError(''); setResult(null)
    try { setResult(await syncFanvuePurchases(modelId, { startDate, endDate })) }
    catch (err) { setError(getApiErrorMessage(err, 'Purchase history import failed')) }
    finally { setBusy(false) }
  }
  return <section className="v2-config-card v2-stack" aria-label="Fanvue purchase history">
    <h3>Purchase history</h3>
    <p>Import actual payments, not the prices of unopened offers. This does not send messages or restart sales. Free subscriptions show $0; unknown amounts remain unknown.</p>
    {status ? <p role="status">{status.ready ? 'Financial access approved.' : status.reason}</p> : <p>Checking financial access…</p>}
    {status?.requires_reauthorization ? <>
      <p>Approve read:insights in Fanvue. Existing chat access stays connected. If Fanvue reports invalid_scope, the app owner must enable this permission in the Developer Area first.</p>
      <button type="button" className="v2-button" disabled={authorizationBusy || busy} onClick={onAuthorize}>Approve financial access</button>
    </> : null}
    <div className="v2-form-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 220px), 1fr))' }}>
      <label className="v2-field"><span>From (UTC, optional)</span><input style={{ minWidth: 0, boxSizing: 'border-box' }} type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></label>
      <label className="v2-field"><span>Before (UTC, optional)</span><input style={{ minWidth: 0, boxSizing: 'border-box' }} type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></label>
    </div>
    <div className="v2-action-row">
      <button type="button" className="v2-button v2-button-secondary" disabled={!status?.ready || busy || authorizationBusy || (startDate && endDate && startDate >= endDate)} onClick={sync}>{busy ? 'Importing…' : 'Import purchases'}</button>
      <button type="button" className="v2-button v2-button-secondary" disabled={busy} onClick={() => { setError(''); setRefresh((v) => v + 1) }}>Refresh access status</button>
    </div>
    {result ? <p role="status">{result.created} added, {result.existing} already recorded, {result.review_required} need financial review. {result.complete ? 'Selected history completed.' : 'Partial import: narrow the date range to fetch older history.'} Refunds and deductions are retained for review, not silently subtracted.</p> : null}
    {error ? <p className="v2-error" role="alert">{error}</p> : null}
  </section>
}
